import React, { Fragment, useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getArticlesById } from "../../actions/article";
import { getProfileById } from "../../actions/profile";

import UserArticleItem from "../layout/Innovators/UserArticleItem";
import LoggedInNav from "../layout/IME/LoggedInNav";
import LoggedOutNav from "../layout/IME/LoggedOutNav";
import TwoFARequest from "../layout/Innovators/TwoFARequest";

const UserArticles = ({
  match,
  auth: { user, channelid, jobtitle, location, verified },
  isAuthenticated,
  getArticlesById,
  getProfileById,
  article: { articles, loading },
  profile: { profile },
}) => {
  const [showAuthentication, setShowAuthentication] = useState(true);

  useEffect(() => {
    getArticlesById(match.params.channelid);
    getProfileById(match.params.channelid);
  }, [getArticlesById, getProfileById]);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {verified && !isAuthenticated && (
        <TwoFARequest
          setShowAuthentication={setShowAuthentication}
          channelid={channelid}
          jobtitle={jobtitle}
          location={location}
        />
      )}
      {!isAuthenticated && <LoggedOutNav />}
      {isAuthenticated && <LoggedInNav />}
      <div className="flex-all-content-fixed">
        <section className="banner-hero-alt">
          <div className="banner-section-name">
            <h1 className="large-font white">Articles</h1>
            {user._id === profile._id && (
              <Link to={`/${user.channelid}/create_article`}>
                <div className="post-action-button">
                  <div className="banner-action-items green">
                    <div className="action-button">
                      <i className="fas fa-book-open fa-lg action-icon-news"></i>
                    </div>
                    <p className="action-text">Create Article </p>
                  </div>
                </div>
              </Link>
            )}
          </div>
        </section>
        <section className="main-body">
          {articles.length > 0 ? (
            <div className="created-content">
              {articles.map((article) => (
                <UserArticleItem
                  key={article._id}
                  article={article}
                  user={user}
                />
              ))}
            </div>
          ) : (
            <p className="empty-content-alt green">No Content</p>
          )}
        </section>
      </div>
    </Fragment>
  );
};

UserArticles.propTypes = {
  auth: PropTypes.object.isRequired,
  getArticlesById: PropTypes.func.isRequired,
  article: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
  article: state.article,
  profile: state.profile,
});

export default connect(mapStateToProps, {
  getArticlesById,
  getProfileById,
})(UserArticles);
